// The client-side half of the contract in
// `backend-nest/src/analytics/stage-roles.ts`, which is the source of truth.
// Kept in step with it deliberately: the two run in different packages, and
// four separate sites once each had their own way of asking "is this stage
// still in play" — one of which detected a win by stage name and counted
// "Closed Lost" as one.
//
// `semanticRole` is NULLABLE and most real stages carry no role at all, so an
// unclassified stage is OPEN. Guessing the other way would silently drop a
// whole funnel out of every metric that reads this.

export const TERMINAL_STAGE_ROLES: ReadonlySet<string> = new Set(['won', 'lost']);

export interface RoledStage {
  semanticRole?: string | null;
}

export function isTerminalStage(stage: RoledStage): boolean {
  return stage.semanticRole ? TERMINAL_STAGE_ROLES.has(stage.semanticRole) : false;
}

export function isOpenStage(stage: RoledStage): boolean {
  return !isTerminalStage(stage);
}
